import React from 'react'

import { rgba } from 'polished'
import styled from 'styled-components'

const MomentItem = styled.div<{ transitionDelay?: number; hide?: boolean }>`
  opacity: ${({ hide }) => (hide ? 0 : 1)};
  position: ${({ hide }) => (hide ? 'absolute' : 'static')};
  transform: ${({ hide }) => (hide ? 'translateY(10px)' : 'none')};
  transition: transform 0.6s;
  transition-delay: ${({ transitionDelay }) =>
    transitionDelay ? `0.${transitionDelay}8s` : 'unset'};

  div {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxs']?.['font-size']?.value};
    font-weight: 500;
    color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    background-color: ${({ theme }) =>
      rgba(theme?.['-ds-core-400']?.value, 0.09)};
    border-radius: 4px;
    padding: 8px;
  }
`

const MomentsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 8px;
`

interface ReviewMomentsProps {
  moments: {
    slug: string
    name: string
  }[]
  showMore: boolean
  truncateLength: number
}

const ReviewMoments = ({
  moments,
  showMore,
  truncateLength,
}: ReviewMomentsProps) => {
  return (
    <MomentsWrapper>
      {moments.slice(0, truncateLength).map((item) => (
        <MomentItem key={item.slug}>
          <div>{item.name}</div>
        </MomentItem>
      ))}

      {moments.length > truncateLength && !showMore && (
        <MomentItem>
          <div>+{moments.length - truncateLength}</div>
        </MomentItem>
      )}

      {moments.slice(truncateLength, moments.length).map((item, index) => (
        <MomentItem key={item.slug} transitionDelay={index} hide={!showMore}>
          <div>{item.name}</div>
        </MomentItem>
      ))}
    </MomentsWrapper>
  )
}

export default ReviewMoments
